import React from 'react';
import { Typography, Paper, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Devoluciones: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Órdenes de Devolución
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => navigate('/inventario/devoluciones/nuevo')}
        sx={{ mb: 2 }}
      >
        Nueva Orden de Devolución
      </Button>
      {/* Aquí irá la tabla de órdenes de devolución */}
    </Paper>
  );
};

export default Devoluciones; 